import React, { useState } from "react";
import { FaTrash, FaSpinner } from "react-icons/fa";
import { useToast } from "../../../Contexts/ToastContext";

const DiscordUnpairedUsersList = ({ users, onRemoveUser }) => {
  const [removingIds, setRemovingIds] = useState(new Set());
   const { showToast } = useToast();

  const handleRemoveClick = async (user) => {
    if (!onRemoveUser) return;
    setRemovingIds((prev) => new Set(prev).add(user.discordUserId));

    try {
      await onRemoveUser(user);
    } catch (err) {
      console.error("Błąd przy usuwaniu użytkownika:", err);
    } finally {
      setRemovingIds((prev) => {
        const next = new Set(prev);
        next.delete(user.discordUserId);
        return next;
      });
       showToast(`Usunięto ${user.displayName || user.userName} z kanału.`, "success");
    }
  };

  return (
    <div className="dc-column">
      <div className="dc-column-title-unpaired">
        Konta Discord bez powiązania &nbsp;
        <span className="dc-column-subtitle">({users.length} kont)</span>
      </div>

      <div className="dc-user-list">
        {users.map((user, i) => (
          <div key={i} className="dc-user-row">
            <div className="dc-discord-user">
              {user.avatarUrl && (
                <img
                  src={user.avatarUrl}
                  alt={user.displayName}
                  className="dc-discord-avatar"
                />
              )}
              <div className="dc-discord-info">
                <span className="dc-discord-display">{user.displayName}</span>
                <span className="dc-discord-username">(@{user.userName})</span>
              </div>
            </div>

            {removingIds.has(user.discordUserId) ? (
              <FaSpinner className="dc-remove-spinner fa-spin" title="Usuwanie..." />
            ) : (
              <FaTrash
                className="dc-remove-icon"
                title="Usuń z kanału"
                onClick={() => handleRemoveClick(user)}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DiscordUnpairedUsersList;
